import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  invalidateChatTokenForMutualFollow,
  invalidateSocialGraph,
} from "Api/Mutations/Social/invalidateSocialGraph";
import {
  type FollowUserResult,
  postSocialFollows,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Translations/Resources";
import { toast } from "sonner";

/**
 * Follows a persona — instantly for Merchants and public Customers, as a follow request for
 * private Customers (idempotent; rules enforced server-side). When following back makes the pair
 * mutual, confirm that first (useMutualFollowConfirm).
 */
export const useFollowUserMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useResource();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (targetIdentityUserPublicID: string) =>
        postSocialFollows({ targetIdentityUserPublicID }),
    ),
    onSuccess: ({ isMutual }: FollowUserResult) => {
      invalidateSocialGraph(queryClient);
      if (isMutual) {
        invalidateChatTokenForMutualFollow(queryClient);
      }
    },
    onError: () => toast.error(t(Resources.Errors.RequestError)),
  });
};
